import { InvoiceTypeEnum } from '@lib/core';
import { BillingData } from './interface/biling-data.interface';

export class PersonalModel implements BillingData {
  invoiceType: number = InvoiceTypeEnum.UNDEFINED;

  companyName: string = null;
  firstName: string = null;
  lastName: string = null;

  street: string;
  streetNumber?: string;
  postalCode: string;
  city: string;

  regon: string;
  taxId: string = null;

  phone: string = null;

  email: string = null;
  emailRepeat: string = null;

  newsletterAgreement = false;
  customAgreement = false;
}
